import React from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipPill } from 'components/Pill';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import getDaysInbetween from 'utils/getDaysInbetween';
import { getSolidBackgroundShade } from 'utils/ui';
import getBasicDate from 'utils/dates/getBasicDate';
import { jsx as _jsx } from "react/jsx-runtime";
export default function EventSessionPill(_ref) {
  var bookingDate = _ref.bookingDate;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // Split off time to ensure we're comparing dates only
  var bookingLocalDate = getBasicDate(new Date(bookingDate));
  var today = getBasicDate(new Date());
  var daysUntilBooking = getDaysInbetween(bookingLocalDate, today);
  var pillText;
  if (daysUntilBooking === 0) {
    pillText = t('state_event_today');
  } else if (daysUntilBooking === 1) {
    pillText = t('state_event_tomorrow');
  } else {
    var formattedDate = getLocalisedDate({
      date: bookingDate,
      options: {
        month: 'short',
        year: 'numeric',
        day: 'numeric'
      },
      isInLocalTimezone: false
    });
    pillText = t('state_event_on_date', {
      date: formattedDate
    });
  }
  var formattedDateTime = getLocalisedDate({
    date: bookingDate,
    isInLocalTimezone: false,
    options: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    }
  });
  return /*#__PURE__*/_jsx(TooltipPill, {
    icon: "calendar",
    iconColor: "calendar",
    title: formattedDateTime || undefined,
    background: getSolidBackgroundShade
    // Move to higher z-index to allow the TooltipPill to receive
    // mouse events for the tooltip when placed in a ContentCard
    ,
    z: "raised",
    children: pillText
  });
}